import axios from "axios";
import React, {useEffect, useState} from "react";
import { useLocation } from "react-router-dom";
import { CircularProgress } from '@mui/material';
import { TextEditor } from "../../components/TextEditor";
import { useParams, useNavigate } from 'react-router-dom';
//import { Editor } from '@tinymce/tinymce-react';

function ModeloEmail() {
    const location = useLocation();
    const { modeloInfo } = location.state || { modeloInfo: null };
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    
    const customFormatSmallDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit'
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens

    const [campos, setCampos] = useState({
        IdModeloEmail: modeloInfo ? modeloInfo.IdModeloEmail : 0,
        emlDescricao: modeloInfo ? modeloInfo.emlDescricao : '',
        emlAssunto: modeloInfo ? modeloInfo.emlAssunto : '',
        emlCorpo: modeloInfo ? modeloInfo.emlCorpo : '',
        emlStatus: modeloInfo ? modeloInfo.emlStatus : 1,
        emlObservacoes: modeloInfo ? modeloInfo.emlObservacoes : '',
        emlCriadoPor: sessionStorage.nomeUsuario,
        emlCriadoEm: customFormatDate,
        emlAlteradoPor: sessionStorage.nomeUsuario,
        emlAlteradoEm: customFormatDate,
        emlCodigoGUID: modeloInfo ? modeloInfo.emlCodigoGUID : crypto.randomUUID()
    });
    
    // console.log('Informações do modelo de email:', modeloInfo);
    // console.log('Informações do campos:', campos);

    function handleInputChange(event) {
        const { name, value } = event.target;
        // modeloInfo[event.target.name] = event.target.value;
        campos[event.target.name] = event.target.value;
        modeloInfo[name] = value;
        setCampos(prevCampos => ({
            ...prevCampos,
            [name]: value
        }));
    }

    function handleFecharModal() {
        window.history.back();
    }
    
    function handleSalvarModelo(e) {
        e.preventDefault();

        if (!campos.emlDescricao || !campos.emlAssunto || !campos.emlCorpo) {
            setErrorMessage('Por favor, preencha os campos obrigatórios: Descrição, Assunto e Corpo do Email.');
            return;
        }
        else {
            setErrorMessage('');
        }

        if (campos.IdModeloEmail === 0) {
            // Criar novo modelo
            axios.post(process.env.REACT_APP_API_URL + '/routes.php?metodo=criarModeloEmail', campos, {
                headers: {
                    'X-Access-Token': tokenAPI,
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            })
            .then(response => {
                console.log('Modelo de email criado com sucesso:', response.data);
                handleFecharModal();
            })
            .catch(error => {
                console.error('Erro ao criar modelo de email:', error);
                setErrorMessage('Ocorreu um erro ao criar o modelo de email. Por favor, tente novamente.');
            });
        } else {
            // Atualizar modelo existente
            axios.post(process.env.REACT_APP_API_URL + '/routes.php?metodo=atualizarModeloEmail', campos, {
                headers: {
                    'X-Access-Token': tokenAPI,
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            })
            .then(response => {
                console.log('Modelo de email atualizado com sucesso:', response.data);
                handleFecharModal();
            })
            .catch(error => {
                console.error('Erro ao atualizar modelo de email:', error);
                setErrorMessage('Ocorreu um erro ao atualizar o modelo de email. Por favor, tente novamente.');
            });
        }
    }

    //const [data] = useState(modeloInfo.emlCorpo || '<p>Texto padrão</p>');

    return (
        <>
            <main>
                <div>
                    {/* fechar */}
                    {/* <div className="d-flex w100 mt1 flex-column text-align-left">
                        <div className='text-align-leeft w80 fs16'>
                            <button 
                                className="close-modal fs16 clrWhite" 
                                onClick={handleFecharModal}>Fechar
                            </button>
                        </div>
                    </div> */}
                    {/* Titulo e subTitulo */}
                    <div className='headerMain'>
                        <label className='labelTitulo' >MODELO DE EMAIL</label>
                        <label className='labelSubTitulo'>Formulário de Cadastro e Alteração</label>
                    </div>
                    {/* Formulario */}
                    <form  className="form-agenda d-flex flex-column w90 mt1" onSubmit={handleSalvarModelo}>
                        <div className="d-flex w100 flex-column tdAlignLeft pb4">
                            {/* Descrição */}
                            <div className="d-flex flex-row divForm">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label>Descrição*</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <input 
                                            type="text"
                                            name="emlDescricao"
                                            id="emlDescricao"
                                            value={campos.emlDescricao}
                                            onChange={handleInputChange}
                                            className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* Assunto */}
                            <div className="d-flex flex-row divForm">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label>Assunto*</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <input 
                                            type="text"
                                            name="emlAssunto"
                                            id="emlAssunto"
                                            value={campos.emlAssunto}
                                            onChange={handleInputChange}
                                            className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* Corpo do Email */}
                            <div className="d-flex flex-row divForm d-none">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label>Corpo do Email*</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <input 
                                            type="text"
                                            name="emlCorpo"
                                            id="emlCorpo"
                                            value={campos.emlCorpo}
                                            onChange={handleInputChange}
                                            className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* Corpo do Email (html) */}
                            <div className="d-flex flex-row divForm">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label>Corpo do Email (html)*</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12 bgWhite'>
                                        <TextEditor 
                                        initialValue={modeloInfo.emlCorpo || ''} 
                                        onChange={handleInputChange}
                                        id="emlCorpo"
                                        name="emlCorpo"
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* Observações */}
                            <div className="d-flex flex-row divForm">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label>Observações</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <input 
                                            type="text"
                                            name="emlObservacoes"
                                            id="emlObservacoes"
                                            value={campos.emlObservacoes}
                                            onChange={handleInputChange}
                                            className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            {/* ALERTAS AVISOS */}
                            {errorMessage !== null && errorMessage !== '' ? (
                                <div className='text-align-left divForm fs10'>
                                    <span className="AlertPassword">
                                        {errorMessage}
                                    </span>
                                </div>
                            ) : (
                                <div></div>
                            )}
                            {/* Botão de Salvar */}
                            <div className='text-align-left mt2 mb4 divForm fs14'>
                                <button type="button" className="buttonGridPadrao2 p1 mr2" onClick={() => navigate(-1)}>Voltar</button>
                                {parseInt(sessionStorage.pesAdmin) === 1 ? (
                                <button type="submit" className="buttonModalSubmit p1">
                                    SALVAR
                                </button>
                                ) : null}
                            </div>
                        </div>
                    </form>
                </div>
            </main>
        </>
    );
}

export default ModeloEmail;